module.exports = __webpack_public_path__ + "media/images/illustrations/Icon-Admissions-4d89fc20590c16dbe2b1d99290f0ead9.svg";